import { SegmentedButton } from '@smartgift/frontend-toolkit';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

import { OrdersTemplate, RecognitionShareTemplate } from '@hero/components/templates';
import { RECOGNITIONS_TAB, RECOGNITION_STATUSES, SOURCE_TYPES } from '@hero/constants';
import { useSendRemindersNotification } from '@hero/hooks';
import { PageLayout } from '@hero/layouts';
import { ROUTE_PATHS } from '@hero/routes';
import {
  useGetRecognition,
  useGetRecognitionSpendingSummary,
  useSendRemindersRecognition
} from '@hero/services/order-service';

import Analytics from './Analytics';
import { OrderSummary } from './Order';
import ThankYouNotes from './ThankYouNotes';

function MyRecognitionDetail() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { recognitionCode } = useParams();
  const query = new URLSearchParams(window.location.search);

  const { data: recognitionDetail } = useGetRecognition({ recognitionCode });
  useGetRecognitionSpendingSummary({
    recognitionCode
  });

  const { send } = useSendRemindersNotification({ useSendReminder: useSendRemindersRecognition });

  const hash = decodeURIComponent(location.hash.slice(1));
  const defaultActiveTab =
    Object.values(RECOGNITIONS_TAB).find(o => o === hash) || RECOGNITIONS_TAB.order;
  const [activeTab, setActiveTab] = useState(defaultActiveTab);

  const onClickSendReminder = () => {
    send(recognitionDetail?.code);
  };

  const isTeams = recognitionDetail?.source === SOURCE_TYPES.teams_app;

  const showShareTab =
    (query.get('status') || recognitionDetail?.status?.current) === RECOGNITION_STATUSES.live &&
    !isTeams;

  const recognitionOptions = [
    {
      value: RECOGNITIONS_TAB.order,
      label: t('overview'),
      children: <OrderSummary setActiveTab={setActiveTab} />
    },
    {
      value: RECOGNITIONS_TAB.analytics,
      label: t('analytics'),
      children: <Analytics setActiveTab={setActiveTab} />
    },
    {
      value: RECOGNITIONS_TAB.recipients,
      label: t('recipients'),
      children: <OrdersTemplate />
    },
    ...(showShareTab
      ? [
          {
            value: RECOGNITIONS_TAB.shareOptions,
            label: t('shareOptions'),
            children: (
              <RecognitionShareTemplate
                onClickSendReminder={onClickSendReminder}
                contactType={recognitionDetail?.contacts?.type}
              />
            )
          }
        ]
      : []),
    {
      value: RECOGNITIONS_TAB.tyNotes,
      label: t('tyNotes'),
      children: <ThankYouNotes />
    }
  ];

  return (
    <PageLayout
      header={{
        title: t('typeNameDetails', { name: t('oneTimeGift') }),
        backButton: {
          onClick: () => navigate(ROUTE_PATHS.MY_RECOGNITIONS)
        }
      }}
    >
      <SegmentedButton
        isPage
        activeTab={activeTab}
        onChange={setActiveTab}
        updateHash
        withLine
        options={recognitionOptions}
      />
    </PageLayout>
  );
}

export { MyRecognitionDetail };
